import { Grid, LinearProgress, Typography } from '@material-ui/core';
import React from 'react';

import useStyle from './styles';

export interface IError {
  helperText: string;
  error: boolean;
}
interface IProps {
  title: string;
  children: React.ReactNode;
  loading: boolean;
  action?: React.ReactNode;
}

export function FormContent(props: IProps) {
  const { children, loading, title, action } = props;
  const classes = useStyle(props);

  return (
    <Grid container className={classes.content}>
      {!!title && (
        <Grid className={classes.titleContent} container justify='space-between' alignItems='center'>
          <Grid item>
            <Typography className={classes.title}>{title}</Typography>
          </Grid>
          {action && (
            <Grid item className={classes.action}>
              {action}
            </Grid>
          )}
          {loading && <LinearProgress className={classes.loadingLinear} />}
        </Grid>
      )}
      <div className={loading ? classes.formSubmiting : classes.form}>{children}</div>
    </Grid>
  );
}
